import { useEffect, useState } from "react";
import { sfx } from "../lib/sound";

/** 3 - 2 - 1 - Go! overlay, then calls onDone. */
export default function Countdown({ onDone }: { onDone: () => void }) {
  const [n, setN] = useState(3);

  useEffect(() => {
    if (n > 0) sfx.tick();
    else sfx.go();

    if (n < 0) {
      onDone();
      return;
    }
    const t = window.setTimeout(() => setN((v) => v - 1), n === 0 ? 550 : 750);
    return () => window.clearTimeout(t);
  }, [n, onDone]);

  const isGo = n === 0;
  const label = n > 0 ? String(n) : isGo ? "GO!" : "";

  return (
    <div
      className="flex min-h-[42vh] items-center justify-center"
      role="status"
      aria-live="assertive"
      aria-label={n > 0 ? `Starting in ${n}` : "Go"}
    >
      <div
        key={label}
        className="animate-pop-in font-display text-8xl italic sm:text-9xl"
        style={{
          color: isGo ? "#36d07a" : "#ffd23f",
          WebkitTextStroke: "5px #1c2a63",
          paintOrder: "stroke",
          filter: "drop-shadow(0 8px 0 #14204d)",
        }}
      >
        {label}
      </div>
    </div>
  );
}
